module.exports = __webpack_public_path__ + "img/icon_jicheng@2x.3195a2b7.png";